// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import desktopElementMng from './metaData/desktopElement'
export default {
  state: desktopElementMng,
  actions
}
